export default __webpack_public_path__ + "adf92df0f6fc09841f97774a067ae0ec.svg";